const FORMAT_CURRENCY = { currency: 'EUR' };
const FORMAT_DATE = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };

const TRACKING = 'BOOKING';

export { FORMAT_CURRENCY, FORMAT_DATE, TRACKING };
